module.exports = __webpack_public_path__ + "img/icn_mail.9dba21a6.svg";